<template>
  <ValidationObserver ref="validator">
    <form novalidate class="md-layout generic-form" @submit.prevent="validate">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <md-card>
          <md-card-content>
            <div class="md-layout">
              <md-field class="md-layout-item md-size-25 md-small-size-100" style="margin:  15px;">
                <label>Template type</label>
                <md-select v-model="selectedEmailTemplateType">
                  <md-option v-for="emailTemplateType in options.emailTemplateType" :key="emailTemplateType" :value="emailTemplateType">
                    {{ emailTemplateType }}
                  </md-option>
                </md-select>
              </md-field>
              <template v-for="lang in options.mailLanguage">
                <md-radio :key="lang" class="md-layout-item md-size-10 md-small-size-100" v-model="language" :value="lang">{{
                  lang
                }}</md-radio>
              </template>
              <div style="display: flex; justify-content: flex-end">
                <md-switch v-model="emailTemplate.use_logo">Use Hotel Logo</md-switch>
              </div>
            </div>
            <div class="md-layout" v-if="showGreetingEditor">
              <span class="md-layout-item">Template Greetings</span>
            </div>
            <div class="md-layout" v-if="showGreetingEditor">
              <div class="md-layout-item">
                <vue2-tinymce-editor
                  :id="'template-geetings'"
                  :value="templateGreetingsContent()"
                  @input="templateGreetingsChange"
                  :options="customToolbar"
                ></vue2-tinymce-editor>
              </div>
            </div>

            <div class="md-layout" v-if="showCloseEditor">
              <span class="md-layout-item">Template for STOP SALES actions</span>
            </div>
            <div class="md-layout" v-if="showCloseEditor">
              <div class="md-layout-item">
                <vue2-tinymce-editor
                  :value="templateCloseContent()"
                  @input="templateCloseChange"
                  :options="customToolbar"
                ></vue2-tinymce-editor>
              </div>
            </div>

            <div class="md-layout" v-if="showBodyEditor">
              <span class="md-layout-item">Template Closure</span>
            </div>
            <div class="md-layout" v-if="showBodyEditor">
              <div class="md-layout-item">
                <vue2-tinymce-editor
                  :id="'template-body'"
                  :value="templateBodyContent()"
                  @input="templateBodyChange"
                  :options="customToolbar"
                ></vue2-tinymce-editor>
              </div>
            </div>
          </md-card-content>

          <md-card-actions>
            <md-button class="md-success" type="submit">Save</md-button>
            <md-button class="md-danger" v-on:click="deleteEmailTemplate" :disabled="edit === false">Delete</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import MailLanguage from '@/openapi/src/model/MailLanguage'
import { EmailTemplateApi, EmailTemplateDTO, EmailTemplateType } from '@/openapi/src'
import { Vue2TinymceEditor } from 'vue2-tinymce-editor'
import Swal from 'sweetalert2'

const emailTemplateApi = new EmailTemplateApi()

export default {
  components: {
    Vue2TinymceEditor,
  },
  data() {
    return {
      edit: false,
      showGreetingEditor: false,
      showBodyEditor: false,
      showCloseEditor: false,
      emailTemplate: {},
      language: new MailLanguage().EN,
      selectedEmailTemplateType: new EmailTemplateType().OFFERS,
      options: {
        mailLanguage: new MailLanguage(),
        emailTemplateType: new EmailTemplateType(),
      },
      customToolbar: {
        menubar: false,
        plugins: 'lists link image paste advlist autolink charmap code codesample hr  ',
        toolbar:
          'undo redo | blocks | fontselect | fontsizeselect | bold italic underline strikethrough| alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link table removeformat codesample code  hr |help',
        a11y_advanced_options: true,
      },
    }
  },
  methods: {
    getTemplate() {
      emailTemplateApi.fetchEmailTemplateByType(this.$root.hotelId, this.selectedEmailTemplateType, (error, template) => {
        if (!error) {
          if (!!template) {
            this.edit = true
            this.emailTemplate = template
          } else {
            this.edit = false
            this.emailTemplate = {
              email_template_type: this.selectedEmailTemplateType,
              use_logo: false,
            }
          }
          this.$nextTick(() => {
            this.refreshEditors()
          })
        }
      })
    },
    templateGreetingsChange(value) {
      if (!this.emailTemplate.template_greetings) {
        this.emailTemplate.template_greetings = {}
      }
      this.emailTemplate.template_greetings[this.language] = value
    },
    templateBodyChange(value) {
      if (!this.emailTemplate.template_body) {
        this.emailTemplate.template_body = {}
      }
      this.emailTemplate.template_body[this.language] = value
    },
    templateCloseChange(value) {
      if (!this.emailTemplate.template_close) {
        this.emailTemplate.template_close = {}
      }
      this.emailTemplate.template_close[this.language] = value
    },
    refreshEditors() {
      this.showGreetingEditor = false
      this.showBodyEditor = false
      this.showCloseEditor = false
      this.$nextTick(() => {
        this.showEditors()
      })
    },
    showEditors() {
      this.showGreetingEditor = true
      this.$nextTick(() => {
        this.showBodyEditor = true
        this.$nextTick(() => {
          this.showCloseEditor = true
        })
      })
    },
    templateGreetingsContent() {
      return !!this.emailTemplate.template_greetings ? this.emailTemplate.template_greetings[this.language] : ''
    },
    templateBodyContent() {
      return !!this.emailTemplate.template_body ? this.emailTemplate.template_body[this.language] : ''
    },
    templateCloseContent() {
      return !!this.emailTemplate.template_close ? this.emailTemplate.template_close[this.language] : ''
    },
    async validate() {
      const isValid = await this.$refs.validator.validate()

      if (!this.emailTemplate.template_greetings) {
        this.emailTemplate.template_greetings = {}
      }
      if (!this.emailTemplate.template_close) {
        this.emailTemplate.template_close = {}
      }
      if (!this.emailTemplate.template_body) {
        this.emailTemplate.template_body = {}
      }

      if (isValid) {
        if (this.edit === true) {
          return this.updateEmailTemplate()
        } else {
          return this.createMailTemplate()
        }
      }
    },
    createMailTemplate() {
      emailTemplateApi.createEmailTemplates(this.$root.hotelId, this.selectedEmailTemplateType, this.emailTemplate, (error) => {
        if (!error) {
          this.edit = true
        }
      })
      this.$notify({
        timeout: 4500,
        message: 'Email Template will be saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
    updateEmailTemplate() {
      emailTemplateApi.updateEmailTemplates(this.$root.hotelId, this.selectedEmailTemplateType, this.emailTemplate, (error) => {
        if (!error) {
          this.edit = true
        }
      })
      this.$notify({
        timeout: 4500,
        message: 'Email Template will be saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
    async deleteEmailTemplate() {
      await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to continue with template delete?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, continue',
        cancelButtonText: 'Cancell',
        customClass: {
          cancelButton: 'md-button md-danger',
          confirmButton: 'md-button md-success',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          emailTemplateApi.deleteEmailTemplates(this.$root.hotelId, this.selectedEmailTemplateType, (error) => {
            this.emailTemplate = {
              email_template_type: this.selectedEmailTemplateType,
              use_logo: false,
            }
            this.edit = false
            this.refreshEditors()
          })
          this.$notify({
            timeout: 4500,
            message: 'Email Template will be delete shortly',
            icon: 'check_box',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'info',
          })
        }
      })
    },
  },
  mounted() {
    this.getTemplate()
  },
  watch: {
    selectedEmailTemplateType: {
      handler: function(newVal) {
        if (newVal && newVal.length > 0 && !!this.language) {
          this.getTemplate()
        }
      },
      deep: true,
    },
    language: {
      handler: function() {
        if (!!this.emailTemplate && !!this.emailTemplate.email_template_type) {
          this.refreshEditors()
        }
      },
    },
  },
}
</script>
<style lang="scss">
body {
  margin: 0rem;
}
</style>
